export default "__VITE_ASSET__De_56Mxj__"